/**
 * Sets the site-wide robots meta from the runtime `noindex` flag
 * (NUXT_PUBLIC_NOINDEX=true on UAT/non-prod). Runs on server + client so the
 * tag is present in the SSR HTML that crawlers read.
 */
export default defineNuxtPlugin(() => {
  const {public: pub} = useRuntimeConfig();
  const noindex = pub.noindex === true || pub.noindex === 'true';
  useHead({
    meta: [
      {
        name: 'robots',
        content: noindex ? 'noindex, nofollow' : 'index, follow',
      },
    ],
  });
});
